import Vue from "vue";
const bpitCommonData = require("bpit.common.data");
const defaultData: any = {
  group: "muse",
  project: "FE-PC-OKR",
  env: process.env.VUE_APP_ENV_TYPE,
  version: process.env.VUE_APP_MUSE_VERSION
};

const commonData = (time: number = 0, data: object = {}): void => {
  if (Vue.$ls.get("userInfo") && Vue.$ls.get("userInfo").workcode) {
    defaultData.workcode = Vue.$ls.get("userInfo").workcode;
  }
  bpitCommonData.log({
    ...defaultData,
    time,
    ...data
  });
};

export default commonData;
